import {
    AutocompleteInput,
    Create,
    FunctionField,
    List,
    NumberField,
    NumberInput,
    ReferenceField,
    ReferenceInput,
    required,
    SimpleForm,
    TextField,
    TextInput
} from 'react-admin';
import AdminPagination from '../AdminPagination';
import AdminSelectableDatagrid from '../AdminSelectableDatagrid';
import HumanDeleteButton from '../HumanDeleteButton';

const userFilters = [<TextInput source="all" label="Rechercher" alwaysOn />];

export const GiftList = (props) => (
    <List {...props} filters={userFilters} bulkActionButtons={false} sort={{ field: '_id', order: 'DESC' }} perPage={50} pagination={<AdminPagination />} exporter={false}>
        <AdminSelectableDatagrid>
            <FunctionField
                label="Date"
                sortBy="_id"
                render={(record) => {
                    if (!record?.id || record.id.length < 8) return '—';
                    const timestamp = parseInt(record.id.substring(0, 8), 16) * 1000;
                    return new Date(timestamp).toLocaleString('fr-FR');
                }}
            />
            <ReferenceField label="Bénéficiaire" source="owner_id" reference="user">
                <FunctionField render={(record) => record!.email} />
            </ReferenceField>
            <NumberField source="pack_count" label="Nombre de packs" />
            <TextField source="unit_count" label="Nombre d’unités" />
            <TextField source="duration" label="Durée" />
            <ReferenceField label="Offert par" source="gifter_id" reference="user">
                <FunctionField render={(record) => record!.email} />
            </ReferenceField>
            <HumanDeleteButton fields={["email", "owner_email", "gifter_email", "code"]} fallback="ce Gift" />
        </AdminSelectableDatagrid>
    </List>
);

export const GiftCreate = (props) => (
    <Create {...props}>
        <SimpleForm redirect="list">
            <ReferenceInput label="Bénéficiaire" source="owner_id" reference="user" validate={required()} perPage={10_000_000} >
                <AutocompleteInput optionText={(record) => `${record?.email}`} translateChoice={false} />
            </ReferenceInput>
            <NumberInput source="pack_count" label="Nombre de packs" min={0} validate={required()} />
            <NumberInput source="unit_count" label="Nombre d’unités" min={0} validate={required()} />
            <NumberInput source="duration" label="Durée" min={0} validate={required()} />
        </SimpleForm>
    </Create>
);
